import { Mail, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAppData } from '../../contexts/AppDataContext.jsx';
import HtmlContent from '../common/HtmlContent.jsx';

export default function Footer() {
  const { data } = useAppData();
  const settings = data?.settings || {};
  const productsHref = data?.navigation?.[0]?.href || data?.home?.categories?.[0]?.href || '/';

  return (
    <footer className="site-footer">
      <span className="footer-seal" aria-hidden="true" />
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <p className="footer-wordmark">La Bella Trading</p>
            <p className="footer-tagline">
              Raw Mediterranean honey &amp; bee products.
              Family owned since 2003 — crafted by nature, bottled with care.
            </p>
          </div>

          <nav className="footer-links" aria-label="Shop">
            <h3>Shop</h3>
            <Link to="/">Home</Link>
            <Link to={productsHref}>Products</Link>
            <Link to="/cart">Cart</Link>
            <Link to="/checkout">Checkout</Link>
          </nav>

          <nav className="footer-links" aria-label="Company">
            <h3>Company</h3>
            <Link to="/about">About</Link>
            <Link to="/services">Services</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/contact">Contact</Link>
          </nav>

          <div className="footer-contact">
            <h3>Get in Touch</h3>
            {settings.contactAddress ? (
              <p><MapPin size={16} /><span>{settings.contactAddress.trim()}</span></p>
            ) : null}
            {settings.contactEmail ? (
              <a href={`mailto:${settings.contactEmail}`}><Mail size={16} /><span>{settings.contactEmail}</span></a>
            ) : null}
            {settings.contactPhone ? (
              <a href={`tel:${settings.contactPhone}`}><Phone size={16} /><span>{settings.contactPhone}</span></a>
            ) : null}
          </div>
        </div>

        <div className="footer-bottom">
          <HtmlContent html={settings.footerCopyright || '&copy; La Bella Trading'} />
          <p>Crafted by nature, bottled with care.</p>
        </div>
      </div>
    </footer>
  );
}
